import { css } from '@linaria/core';
const iconIdleStyles = `
	.accent-01 {
		fill: rgb(var(--icon-color-idle-01));
	}

	.accent-02 {
		fill: rgb(var(--icon-color-idle-02));
	}

	.accent-03 {
		fill: rgb(var(--icon-color-idle-03));
	}
`;
/* Specific icon styles for integration in primary button */
export const iconIdlePrimaryStyles = `
	.accent-01 {
		fill: rgb(var(--icon-color-hover-01));
	}

	.accent-02 {
		fill: rgb(var(--icon-color-hover-02));
	}

	.accent-03 {
		fill: rgb(var(--icon-color-hover-03));
	}
`;
const iconBaseHoverFocusStyles = `
	.accent-01 {
		fill: rgb(var(--icon-color-hover-01));
	}

	.accent-02 {
		fill: rgb(var(--icon-color-hover-02));
	}

	.accent-03 {
		fill: rgb(var(--icon-color-hover-03));
	}
`;
export const iconDisabledStyles = `
	.accent-01 {
		fill: rgb(var(--icon-color-hover-01), 0.4);
	}

	.accent-02 {
		fill: rgb(var(--icon-color-hover-02), 0.4);
	}

	.accent-03 {
		fill: rgb(var(--icon-color-hover-03), 0.4);
	}
`;
export const iconHoverFocusStyles = `
	&:focus-visible {
		${iconBaseHoverFocusStyles};
	}

	@supports not selector(:focus-visible) {
		&:focus {
			${iconBaseHoverFocusStyles};
		}
	}

	&:hover {
		@media (any-hover: hover), (any-pointer: fine) {
			${iconBaseHoverFocusStyles};
		}
	}
`;
export const Root = {
    base: css `
		${iconIdleStyles};
		${iconHoverFocusStyles};
	`,
};
